<template>
  <a @click="DeleteOnboarding">Delete</a>

  
</template>
<script>

    import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';
    import TCVelikClient from '@/TCVelikClient/TCVelikClient';
    export default({
        components:{
            ToolButton
    },
    props: ["Id","home_redirect"],
    methods: {
      
      DeleteOnboarding() {
        var instance = this;
        if (confirm('Are you sure you want to delete this onboarding?')) {
          const mutation = `mutation DeleteOnboarding($id: Int!) {
          deleteOnboarding(id: $id)
          }`;

          const variables = {
              id: this.Id * 1
            };

           const req = {
            query: mutation,
            variables
           };


          return TCVelikClient.PostRelative("/api/graphql", req, {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            }
          })
            .then(response => {
              if (instance.home_redirect == true) {
                alert("Successfully deleted onboarding")
                this.$router.push({ path: '/pages/home' });
              }
              else {
                location.reload()
              }
            })
            .catch(error => {
              alert("Error deleting onboarding", error);
            });
        } else {
          return;
        }

       
      }
    },
        
    });
</script>
